import { Breadcrumbs as NovaBaseBreadcrumbs } from '@fme-nova/components'
import { Breadcrumbs as MuiBaseBreadcrumbs, BreadcrumbsProps, styled } from '@mui/material'

import { COLORS, createComponentWrapperWithRef, THEME_CONST } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiBreadcrumbs: MsdkStyledComponent<BreadcrumbsProps> = styled(MuiBaseBreadcrumbs)`
  padding: ${THEME_CONST.defaultPadding}px;
  background-color: ${COLORS.white.main};
`

const NovaBreadcrumbs: MsdkStyledComponent<BreadcrumbsProps> = styled(NovaBaseBreadcrumbs)`
  padding: ${THEME_CONST.defaultPadding}px;
  background-color: ${COLORS.white.main};
`

export const Breadcrumbs = createComponentWrapperWithRef<BreadcrumbsProps>(
  {
    mui: MuiBreadcrumbs,
    nova: NovaBreadcrumbs,
  },
  'Breadcrumbs',
)
